import { useState } from "react";

export const isoFromFlag = (f) => {
  const cps = [...(f || "")].map((c) => c.codePointAt(0) - 127397);
  return cps.length === 2 && cps.every((c) => c >= 65 && c <= 90) ? String.fromCharCode(...cps).toLowerCase() : null;
};

const names = typeof Intl !== "undefined" && Intl.DisplayNames ? new Intl.DisplayNames(["en"], { type: "region" }) : null;
export const countryName = (code) => { try { return names?.of(code.toUpperCase()) || code.toUpperCase(); } catch { return code.toUpperCase(); } };

/* Self-hosted SVG flags (public/flags, flag-icons set) so every OS and browser renders the same artwork; circular chip or 4:3 pill. Hover shows the country name. */
export function Flag({ flag, iso, name, size = 22, rect = false, className = "" }) {
  const [missing, setMissing] = useState(false);
  const code = iso?.toLowerCase() || isoFromFlag(flag);
  if (!code) return flag ? <span aria-hidden="true">{flag}</span> : null;
  const label = name || countryName(code);
  const w = size, h = rect ? Math.round(size * 0.75) : size;
  return (
    <span className={`flag-chip relative inline-grid shrink-0 place-items-center overflow-hidden align-middle bg-gray6 ring-1 ring-inset ring-black/10 ${rect ? "rounded-[4px]" : "rounded-full"} ${className}`} style={{ width: w, height: h }} data-tip={label} aria-label={label} role="img">
      {missing
        ? <span aria-hidden="true" className="font-semibold text-label2" style={{ fontSize: Math.max(8, Math.round(size * 0.38)), lineHeight: 1 }}>{code.toUpperCase()}</span>
        : <img src={`/flags/${rect ? "4x3" : "1x1"}/${code}.svg`} alt="" width={w} height={h} loading="lazy" decoding="async" draggable={false} onError={() => setMissing(true)} className="h-full w-full object-cover" />}
    </span>
  );
}
